import { Outlet } from 'react-router';

import { Navigate } from '@sorare/routing';
import { ANY_SPORT_HOME } from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import { useEnableSetFeatures } from '@sorare/core/src/hooks/commonGame/useEnableSetFeatures';
import { RequireAuth } from '@sorare/core/src/routing/RequireAuth';

const SeriesLayout = () => {
  const { generateSportContextPath } = useSportContext();
  const enableSetFeatures = useEnableSetFeatures();

  if (!enableSetFeatures) {
    return (
      <Navigate
        to={generateSportContextPath(ANY_SPORT_HOME)}
        replace
        keepSearchParams
      />
    );
  }
  return (
    <RequireAuth>
      <Outlet />
    </RequireAuth>
  );
};

export default SeriesLayout;
